import { Flow } from 'signup-constants/Flow';
import { getIntentLink } from '../intents/intentSelectors';
import { isFlow } from '../utils/isFlow';
import { getIsUserFromFreeCrmPage } from './acq135/acq135Utils';
import { enrollOnFlow } from './experimentDefaults';
import { ExperimentKeys, TEST_KEY } from './ExperimentKeys';
import { getIsNewUserExperiment } from './ExperimentUtils';
export const EXPERIMENT_ID = 'experimentId';
const SEEN_EXPERIMENTS = new Set();
const Experiments = new Map([[ExperimentKeys.ACQ131, {
  shouldEnroll: state => {
    const isEnrolledFlow = isFlow([Flow.Crm, Flow.Marketing, Flow.Sales, Flow.Service]);
    const isNewUser = getIsNewUserExperiment(state);
    const isUserFromFreeCrmPage = getIsUserFromFreeCrmPage();
    return isEnrolledFlow && isNewUser && !isUserFromFreeCrmPage;
  }
}], [ExperimentKeys.BIAB004, {
  shouldEnroll: state => {
    return isFlow(Flow.Crm) && !getIntentLink(state);
  }
}], [ExperimentKeys.ACQ128, {
  shouldEnroll: state => {
    const isEnrolledFlow = isFlow([Flow.Crm, Flow.Sales, Flow.Service]);
    const isNewUser = getIsNewUserExperiment(state);
    return isEnrolledFlow && isNewUser && !getIsUserFromFreeCrmPage();
  }
}], [ExperimentKeys.ACQ133, {
  shouldEnroll: state => {
    const isEnrolledFlow = isFlow([Flow.Crm, Flow.Marketing, Flow.Sales, Flow.Service]);
    const isNewUser = getIsNewUserExperiment(state);
    return isEnrolledFlow && isNewUser;
  }
}]]);
export const getExperiment = id => {
  // we want to prefer this solution over mocking getExperiment so that the
  // seen experiments tracking below continues to work and doesn't get
  // accidentally mocked
  if (id === TEST_KEY) {
    return {
      shouldEnroll: () => enrollOnFlow([Flow.Crm])
    };
  }

  SEEN_EXPERIMENTS.add(id);
  return Experiments.get(id);
};
export function getSeenExperimentsForTesting() {
  return Array.from(SEEN_EXPERIMENTS);
}